import React, { Component } from 'react';
import * as Table from 'reactabular-table';
import * as sort from 'sortabular';
import * as Search from 'searchtabular';
import { Glyphicon, OverlayTrigger, Tooltip, Button, PageHeader, Grid, Row, Col, Pagination, } from 'react-bootstrap';
import { orderBy, map } from 'lodash';
import { getTariffRates, removeTariffRate } from 'utils/TariffRatesAPIUtils';
import { updateContract } from 'utils/ContractsAPIUtils';
import TariffRatesEditModal from './TariffRatesEditModal';
import paginate from 'utils/pagination-util';
import Store from 'stores/TariffRatesStore';
export default class TariffList extends Component {
    constructor(props) {
        super(props);
        this.onPerPage = (e) => {
            const pagination = this.state.pagination || {};
            pagination.perPage = parseInt(e.target.value, 10);
            this.setState({
                pagination: pagination,
            });
        };
        const getSortingColumns = () => this.state.sortingColumns || {};
        const sortable = sort.sort({
            getSortingColumns,
            onSort: (selectedColumn) => {
                this.setState({
                    sortingColumns: sort.byColumns({
                        // sort.byColumn would work too
                        sortingColumns: this.state.sortingColumns,
                        selectedColumn,
                    }),
                });
            },
        });
        this.state = {
            tariffRates: [],
            editedCell: null,
            query: {},
            searchColumn: 'all',
            sortingColumns: null,
            showEditor: false,
            columns: [
                {
                    property: 'name',
                    header: {
                        label: 'Name',
                        formatters: [
                            sort.header({
                                sortable,
                                getSortingColumns,
                                strategy: sort.strategies.byProperty,
                            }),
                        ],
                    },
                    cell: {
                        formatters: [Search.highlightCell],
                    },
                },
                {
                    property: 'type',
                    header: {
                        label: 'Type',
                        formatters: [
                            sort.header({
                                sortable,
                                getSortingColumns,
                                strategy: sort.strategies.byProperty,
                            }),
                        ],
                    },
                    cell: {
                        formatters: [Search.highlightCell],
                    },
                },
                {
                    header: {
                        formatters: [
                            () => (React.createElement(Button, { bsSize: "xsmall", className: "btn btn-default", onClick: this.newTariffRate() }, "New TariffRate")),
                        ],
                    },
                    cell: {
                        formatters: [
                            (value, { rowData }) => {
                                const tariffRate = rowData;
                                const remove = (password) => {
                                    this.handleTariffRateDelete(tariffRate, password);
                                };
                                const edit = () => {
                                    this.setState({ showEditor: true, tariffRate: tariffRate });
                                };
                                return (React.createElement("span", null,
                                    React.createElement(OverlayTrigger, { placement: "top", overlay: React.createElement(Tooltip, { id: "remove" }, "Remove") },
                                        React.createElement(Glyphicon, { glyph: "remove", style: { cursor: 'pointer', color: 'red' }, onClick: remove })),
                                    "\u00A0",
                                    React.createElement(OverlayTrigger, { placement: "top", overlay: React.createElement(Tooltip, { id: "edit" }, "Edit") },
                                        React.createElement(Glyphicon, { glyph: "edit", style: { cursor: 'pointer', color: 'green' }, onClick: edit }))));
                            },
                        ],
                    },
                },
            ],
            pagination: {
                page: 0,
                perPage: 10,
            },
        };
        this.onChange = () => this.onStoreChange();
    }
    componentDidMount() {
        Store.addChangeListener(this.onChange);
        if (this.props.contract._id) {
            getTariffRates(this.props.contract._id);
        }
        else {
            Store.clearAll();
        }
    }
    componentWillUnmount() {
        Store.removeChangeListener(this.onChange);
    }
    onStoreChange() {
        this.setState({ tariffRates: Store.getTariffRates() }, () => {
            if (Store.getIsAddOrRemove()) {
                const contract = this.props.contract;
                if (contract) {
                    contract.tariff_rates = map(Store.getTariffRates(), '_id');
                    updateContract(contract);
                }
                Store.setIsAddOrRemove();
            }
        });
    }
    onSearch(search) {
        this.setState({
            editedCell: null,
            search: search,
        });
    }
    newTariffRate() {
        return () => {
            this.setState({ showEditor: true });
        };
    }
    handleTariffRateDelete(tariffRate, password) {
        if (tariffRate) {
            Store.reset();
            removeTariffRate(tariffRate, password);
        }
    }
    onSelect(eventKey) {
        const pagination = this.state.pagination || {};
        pagination.page = eventKey - 1;
        this.setState({
            pagination: pagination,
        });
    }
    render() {
        let tariffRates = this.state.tariffRates;
        const columns = this.state.columns;
        const searchColumn = this.state.searchColumn;
        const pagination = this.state.pagination;
        const query = this.state.query;
        const showEditor = this.state.showEditor;
        const sortingColumns = this.state.sortingColumns;
        if (tariffRates && query) {
            tariffRates = Search.highlighter({
                columns: columns,
                matches: Search.matches,
                query,
            })(Search.multipleColumns({ columns, query })(tariffRates));
        }
        tariffRates = sort.sorter({
            columns: columns,
            sortingColumns,
            sort: orderBy,
        })(tariffRates);
        let totalPages = 0;
        if (pagination.perPage && tariffRates) {
            totalPages = Math.ceil(tariffRates.length / pagination.perPage);
        }
        const tariffRate = this.state.tariffRate;
        const paginated = paginate(tariffRates, pagination);
        const close = () => {
            this.setState({ showEditor: false, tariffRate: null });
        };
        let modal = React.createElement("div", null);
        if (showEditor) {
            modal = (React.createElement(TariffRatesEditModal, { className: "contract-wrapper", tariffRate: tariffRate, onClose: close, show: true }));
        }
        return (React.createElement("div", { className: "contract-wrapper" },
            React.createElement(PageHeader, null, "TariffRates"),
            React.createElement(Grid, { fluid: true },
                React.createElement(Row, { className: "show-grid row-centered" },
                    React.createElement(Col, { xs: 4, className: "fixed col-left" },
                        React.createElement("label", null,
                            "Per page",
                            ' ',
                            React.createElement("input", { type: "number", defaultValue: pagination.perPage, onChange: this.onPerPage }))),
                    React.createElement(Col, { xs: 4, className: "col-centered" },
                        React.createElement("h4", null, `Page ${pagination.page + 1} of ${totalPages}`)),
                    React.createElement(Col, { xs: 4, className: "col-right" },
                        React.createElement("div", { className: "search-container" },
                            React.createElement("span", null, "Search"),
                            React.createElement(Search.Field, { column: searchColumn, query: query, data: this.state.tariffRates, columns: columns, rows: paginated.data, onColumnChange: (searchColumn) => this.setState({ searchColumn }), onChange: (query) => this.setState({ query }) }))))),
            React.createElement("div", null,
                React.createElement(Table.Provider, { className: "default-table", columns: columns },
                    React.createElement(Table.Header, null),
                    React.createElement(Table.Body, { rows: paginated.data, rowKey: "_id" }))),
            React.createElement("div", { className: "controls" },
                React.createElement(Pagination, { prev: true, next: true, first: true, last: true, ellipsis: true, items: paginated.amount, maxButtons: 5, activePage: pagination.page + 1, onSelect: (eventKey) => this.onSelect(eventKey) })),
            React.createElement("div", null, modal)));
    }
}
